<ng-template #blockTemplate let-blockConfig='blockConfig' let-inTab='inTab' let-index='index'>
  @switch (blockConfig.type) {
    <!-- CALENDAR BASED ALLOTMENT -->
    @case ("calendar") {
      <dataset-list
        #listBlocks
        [showTitle]='enableBlocks.length > 1'
        [autoFetchData]='true'
        [datasetCode]='blockConfig.datasetCode'
        [filters]='blockFilters[index]'
        [parentDatasetRS]='datasetRS'
        [parentDatasetACS]='datasetACS'
        [conditionalShowPaginationToolbar]='true'
        [showSearchBar]='false'
        [elevate]='false'
        [showTitle]='!inTab'
        (created)='onCreatedInBlock(blockConfig)'
        (datasetEvent)='onDatasetEvent($event)'
      ></dataset-list>
    }
    <!-- FORM FIXED ALLOTMENT -->
    @case ("form") {
      <form-fixed-allotment
        [stepConfig]='stepConfig'
        [hasNext]='true'
        [hasPrevious]='true'
        (nextStep)='stepper.next()'
      ></form-fixed-allotment>
    }
    <!-- NOT CONFIGURED DATASET -->
    @default {
      <div>
        <p>{{'Blocco non configurato' | translate}}: {{blockConfig.type}}</p>
      </div>
    }
  }
</ng-template>

<div class='full-form'>
  <ng-container>
    @for (blockConfig of stepConfig.options.blocks; track blockConfig; let i = $index) {
      @if (enableBlocks[i]) {
        <ng-container
          [ngTemplateOutlet]='blockTemplate'
          [ngTemplateOutletContext]='{blockConfig: blockConfig, inTab: false, index: i}'
        ></ng-container>
      }
    }
  </ng-container>
</div>